export default "__VITE_ASSET__BMtToExj__"